import * as firebase from 'firebase/app';
import { MessagePayload, Unsubscribe, getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { getAnalytics, logEvent } from 'firebase/analytics';

const config = {
  apiKey: 'AIzaSyAQQ9fM4SLcRhd648pLUVeKfKiYu7n8-8s',
  authDomain: 'simplify-driver-app.firebaseapp.com',
  databaseURL: 'https://simplify-driver-app.firebaseio.com',
  projectId: 'simplify-driver-app',
  storageBucket: 'simplify-driver-app.appspot.com',
  messagingSenderId: '294344896773',
  appId: '1:294344896773:web:30f1cb5542e63412a2476c',
  measurementId: 'G-9S7QEJ7WMQ'
};

firebase.initializeApp(config);

// const messaging = getMessaging();

export const requestForToken = async () => {
  const vapidKey = 'BEksUQ7fy7p6Nk7O4OPAspGBJ9ChhrUgaM0ag9AZovtPrn26lj9qtkfaBqMJr4g31AYMUTjL0dBz_tRZ0yo8_Lk';
  try {
    const supported = await isSupported();

    if (!supported) {
      console.warn('Firebase messaging is not supported in this browser');
      return null;
    }

    const messaging = getMessaging();
    const currentToken = await getToken(messaging, { vapidKey });
    if (currentToken) {
      return currentToken;
    } else {
      console.log('no registration token available. Please request token.');
    }
  } catch (err) {
    console.log('error occured while retrieving token.', err);
  }
};

/**
 * Listen to push messages that arrive while the app is in the foreground.
 *
 * Takes a handler and hands back the function that stops listening, or null when the browser has no
 * messaging support. It used to resolve a promise with the first message instead, which meant every
 * push after that first one was silently dropped for the rest of the session.
 */
export const onMessageListener = async (handler: (payload: MessagePayload) => void): Promise<Unsubscribe | null> => {
  const supported = await isSupported();

  if (!supported) {
    return null;
  }

  const messaging = getMessaging();

  return onMessage(messaging, handler);
};

export const CreateLogEvent = (eventName: string, currentUser: CurrentUser) => {
  try {
    const analytics = getAnalytics();

    const { id, displayName, tenant } = currentUser!;

    logEvent(analytics, `web_${eventName}_${process.env.NODE_ENV}`, {
      sim_employeeId: id,
      sim_employeeName: displayName,
      sim_employeeTenant: tenant
    });
  } catch (err) {
    console.warn('Firebase analytics skipped:', err);
  }
};
export default firebase;
